module.exports = __webpack_public_path__ + "static/images/checkmark-in-circle-thick.2488df3fdeedb7db41fd4cf476c5eb50.svg";